import React from 'react';
import Header from './../../Header';
import Footer from './../../Footer';
import Loader from './../../Loader';
import Menu from './../../Menu';
import HeroLayout from './../Details/HeroLayout';
import RelatedProjects from './../Details/RelatedProjects';
import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchLinkedProjects } from "./../../../actions/projectActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import ReactFullpage from '@fullpage/react-fullpage';
import { Helmet } from 'react-helmet';
import ReactHtmlParser from 'react-html-parser';
import ReactGA from 'react-ga';

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true,
            seo: false
        }
    }
    componentDidMount() {
        let {link_type} = this.props.match.params;
        let _this = this;
		ReactGA.pageview('/projects/'+link_type);

        Promise.all([
            this.props.dispatch(fetchMenu('menu')),
            this.props.dispatch(fetchLinkedProjects()),
            this.props.dispatch(fetchOptions()),
            fetch(process.env.REACT_APP_API_URL+'yoast/v1/get_head?url='+process.env.REACT_APP_WP_URL+'lelay_projects/'+link_type+'/')
                .then(response => response.json())
                .then(json => {
                    _this.setState((prevState) => ({
                        ...prevState,
                        seo: json.head
                    }))
                })
        ]).then(() => {
            this.setState({
                pageLoading: false
            })
        });
    }

    render() {
		let { menu } = this.props.menu;
        let _this = this;
        let {link_type} = this.props.match.params;

        let projects = this.props.projects && Object.keys(this.props.projects.linkedData).length ? this.props.projects.linkedData[link_type] : [];
        let projectList = projects[0];

        let related_projects = [];
        let Fullpage = [];

        if(projectList != undefined){
            let related_projects_arr = projectList.related_projects;
            if(related_projects_arr && related_projects_arr.length){
                related_projects = projects.filter((item) => {
                    return related_projects_arr.indexOf( item.ID ) >= 0;
                });
            }
    
            let layoutData = projectList.layout.map((row, index) => {
                return (<div className="section" dangerouslySetInnerHTML={{ __html: row }} key={index} />)
            })
            Fullpage = () => (
                <ReactFullpage
                    //normalScrollElements= '.recent-project-section'
                    scrollOverflow={true}
                    offsetSections={true}
                    licenseKey={process.env.REACT_APP_FULLPAGE_LICENSE}
                    responsiveWidth={process.env.REACT_APP_FULLPAGE_BREAKPOINT}
                    afterLoad={
                        function (origin, destination, direction) {
                            let tag = destination.item.getElementsByTagName('section') && destination.item.getElementsByTagName('section')[0] ? destination.item.getElementsByTagName('section')[0] : '';
                            let ham = tag && tag.attributes['data-hammenu'] ? tag.attributes['data-hammenu'].nodeValue : '';
                            let dis = destination.isFirst ? 1 : 0;
                            if(document.querySelector('header')){
                                document.querySelector('.ll-logo').style.opacity = dis;
                                document.querySelector('.ll-logo img').style.opacity = dis;
                                if(ham)
                                    document.querySelector('header').classList.add(ham)
                            }
                        }
                    }
                    onLeave={
                        function (origin, destination, direction) {
                            let dis = destination.isFirst ? 1 : 0;
                            if(document.querySelector('header')){
                                document.querySelector('header').classList.remove('white')
                                document.querySelector('.ll-logo').style.opacity = dis;
                                document.querySelector('.ll-logo img').style.opacity = dis;
                            }
                        }
                    }
                    render={({ state, fullpageApi }) => {
                        return (
                            <ReactFullpage.Wrapper>
                                <div className="section"><HeroLayout {..._this.props} details={projectList}  handleClickBelow={() => fullpageApi.moveTo(2)} white={false} /></div>
                                {layoutData}
                                <RelatedProjects {..._this.props} related_projects={related_projects}  handleClickTop={() => fullpageApi.moveTo(1)} />
                                <Footer {..._this.props} />
                            </ReactFullpage.Wrapper>
                        );
                    }}
                />
            );
        }
        

        

        return (
            <React.Fragment>
                {
                    this.state.seo &&
                        <Helmet>
                        {ReactHtmlParser(this.state.seo)}
                    </Helmet>
                }
                <main className="ll__project-details">
                    {this.state.pageLoading &&
                        <Loader />
                    }
                    <Header headerTheme={''} {..._this.props} />
                    {
                        projectList &&
                            <Fullpage {...this.props} />

                    }
                </main>
                {menu.primary &&
                    <Menu {...this.props} />
                }
            </React.Fragment>
        );
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Projects/LinkedProject/index.js